import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Media,
  ControlLabel,
  FormControl,
  FormGroup,
  Label,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class familyBulk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      cfpassword: "",
      process: false,
      errors: [],
      useraccess: "",
      errormessage: "",
      btnDisabled: true,
      btnText: "Submit",
      profile_data: "",
      processing: true,
      errormessages: [],
      profile: "",
      message: "",
      selectedFile: [],
      country_detail: [],
      city_info: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }
  onDownload = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    alert("on downlaod butto clicked");
    const link = document.createElement("a");
    link.href =
      "https://flash-prod.s3.ap-south-1.amazonaws.com/flash-health-manager/sample+family+upload.xlsx";
    link.target = "_blank";
    // document.body.appendChild(link)
    link.click();
  };
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    var token = JSON.parse(localStorage.getItem("user"));
    if (token.role != 1 && token.role != 2) {
      this.props.history.push("/dashboard");
    }
    this.setState({
      useraccess: token.role,
    });
    const obj = token.token;
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>user</b> - uploaded successfully. .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async onSubmit() {
    this.setState({
      errormessages: [],
      btnDisabled: true,
      btnText: "Processing",
    });

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (!this.state.profile || this.state.profile.length === 0) {
      alert("Please upload Excel file");
      this.setState({ btnDisabled: false, btnText: "Submit" });
      return;
    }

    this.setState({ processing: true });

    const fdata = new FormData();
    fdata.append("csv_file", this.state.profile);

    const url = process.env.REACT_APP_NOT_SECRET_CODE + "/bulk-upload-family";
    const position = "bl";

    axios
      .post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "Content-Type": "multipart/form-data",
          "X-Request-Id": "124",
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ message: res.data.message });
          this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-check"></span>,
            message: <div>{res.data.message}</div>,
            level: "success",
            position: position,
            autoDismiss: 10,
          });
        } else {
          const errorMessage = res.data.message || "Operation failed";
          this.setState({ message: errorMessage });
          this.state._notificationSystem.addNotification({
            title: (
              <span data-notify="icon" className="pe-7s-close-circle"></span>
            ),
            message: (
              <div>
                <b>Error:</b> {errorMessage}
              </div>
            ),
            level: "error",
            position: position,
            autoDismiss: 10,
          });
        }
      })
      .catch((error) => {
        let errorMsg = "Network error. Please try again.";
        if (error.response) {
          errorMsg = error.response.data.message || error.response.statusText;
        } else if (getApiErrorMessage(error)) {
          errorMsg = getApiErrorMessage(error);
        }

        this.setState({ message: errorMsg });
        this.state._notificationSystem.addNotification({
          title: (
            <span data-notify="icon" className="pe-7s-close-circle"></span>
          ),
          message: (
            <div>
              <b>Error:</b> {errorMsg}
            </div>
          ),
          level: "error",
          position: position,
          autoDismiss: 10,
        });
      })
      .then(() => {
        this.setState({
          btnText: "Submit",
          btnDisabled: false,
          processing: false,
        });
      });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleFileChange(event) {
    this.setState({ profile: event.target.files[0], btnDisabled: false });
  }
  upload() {
    document.getElementById("selectImage").click();
  }

  render() {
    const errormessage = this.state.errormessage;
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Family Bluk Excel</ControlLabel>
                          <br></br>
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            className="form-control"
                            name="profile"
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.profile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.profile == ""
                              ? "Choose Excel"
                              : "Change Excel"}
                          </Button>
                        </FormGroup>

                        <Button
                          class="btn-color"
                          disabled={this.state.btnDisabled}
                          onClick={this.onSubmit.bind(this)}
                          fill
                        >
                          {this.state.btnText}
                        </Button>

                        <div>
                          <br />
                          <br />
                          {this.state.message != "" && (
                            <h6>{this.state.message}</h6>
                          )}
                          <br />

                          {this.state.errors.length != 0 && (
                            <React.Fragment>
                              <h5>Errors</h5>
                              <ul>
                                {this.state.errors.map((index) => {
                                  return <li>{index}</li>;
                                })}
                              </ul>
                            </React.Fragment>
                          )}
                        </div>
                        <div>
                          <br />
                          <Button
                            class="btn-color"
                            onClick={this.onDownload.bind(this)}
                            fill
                          >
                            Download Sample Excel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default familyBulk;
